import { t } from "@/i18n-js/instance";
import { LineChartComponent } from "@/react/components/Analytics/components/LineChartComponent";
import { i18nRoot } from "../../constants";
import {
  completionColors,
  completionData,
  completionSeriesKeys,
} from "../constants";

export const CompletionChart = () => (
  <div className="mb-8">
    <LineChartComponent
      title={t([i18nRoot, "analytics.chart.completion_timeline.title"])}
      tooltip={t([i18nRoot, "analytics.chart.completion_timeline.tooltip"])}
      data={completionData}
      indexBy="label"
      seriesKeys={completionSeriesKeys}
      colors={completionColors}
      suffix="%"
      rootLocale={[i18nRoot, "analytics.chart.completion_timeline.lines"]}
      className="w-full"
    />
  </div>
);
